import axios from '@/utils/axios'
// 列表
export function listMedia(query) {
    return axios({
        url: '/novelInfo/getNovelMedia',
        method: 'get',
        params: query
    })
}
// 详情
export function details(query) {
    return axios({
        url: '/novelInfo/getNovelMediaByBookId',
        method: 'get',
        params: query
    })
}
// 授权
export function authorize(query) {
    return axios({
        url: '/novelInfo/authorize',
        method: 'get',
        params: query
    })
}
// 修改资源上架状态
export function operateStauts(query) {
    return axios({
        url: '/novelInfo/operateNovelByBookId',
        method: 'get',
        params: query
    })
}